import axios from 'axios';

// 기본 Axios 인스턴스의 기본 URL 설정
axios.defaults.baseURL = '/'; // 모든 요청에 '/' 추가 => 운영
// axios.defaults.baseURL = '/web'; // 모든 요청에 '/web' 추가 => 개발

//  axios.defaults.baseURL = '/web'; // 모든 요청에 '/web' 추가 => 개발